<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");
    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === "undefined"
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
}

// 使用方法
var paramValue = getUrlParameter("type");
var _czc = _czc || [];
(function () {
  var um = document.createElement("script");
  um.src = "https://s4.cnzz.com/z.js?id=1281417754&async=1";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(um, s);
})();
if (paramValue != "hide") {
  (function () {
    var _53code = document.createElement("script");
    _53code.src = "https://tb.53kf.com/code/code/10177911/1";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(_53code, s);
  })();
}

import { mapGetters } from "vuex";
export default {
  name: "App",
  computed: {
    ...mapGetters(["token"]),
  },
  mounted() {
    //移动端访问重定向
    // if (this.isMobile()) {
    //     window.location.href = "https://m.yousanxia.com"
    // }
  },
  methods: {
    //该方法用于判断是否进入手机端
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/tailwind.scss";

#icon_module {
  top: 50px !important;
}

body,
html {
  font-size: 10px;
  margin: 0 auto;
}

* {
  margin: 0;
  padding: 0;
}
</style>
